/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedTradePointsEarnedMessage_tradeFirm = {
    readonly " $fragmentRefs": FragmentRefs<"PointsEarnedMessage_tradeFirm">;
    readonly " $refType": "PdpSharedTradePointsEarnedMessage_tradeFirm";
};
export type PdpSharedTradePointsEarnedMessage_tradeFirm$data = PdpSharedTradePointsEarnedMessage_tradeFirm;
export type PdpSharedTradePointsEarnedMessage_tradeFirm$key = {
    readonly " $data"?: PdpSharedTradePointsEarnedMessage_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedTradePointsEarnedMessage_tradeFirm">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedTradePointsEarnedMessage_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PointsEarnedMessage_tradeFirm",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'cd5c96a8a950ade875c59bb29fee1ca5';
export default node;
